module.exports = __webpack_public_path__ + "static/media/s8.21c436b2.png";